export default function MostImprovedAJSSCard({ ajss, selectedYear }) {
  const data = ajss.filter(
    (r) => Number(r.year) === Number(selectedYear)
  );

  const players = {};
  data.forEach(r => {
    const key = `${r.playerId}_${r.ageGroup}`;
    if (!players[key]) {
      players[key] = {
        name: r.playerName,
        ageGroup: r.ageGroup,
        ranks: []
      };
    }
    if (typeof r.rank === "number") {
      players[key].ranks.push(r.rank);
    }
  });

  let best = null;
  let bestImprovement = -Infinity;

  Object.values(players).forEach(p => {
    if (p.ranks.length > 1) {
      const worst = Math.max(...p.ranks);
      const bestRank = Math.min(...p.ranks);
      const improvement = worst - bestRank;

      if (improvement > bestImprovement) {
        bestImprovement = improvement;
        best = {
          playerName: p.name,
          ageGroup: p.ageGroup,
          improvement,
          worst,
          best: bestRank
        };
      }
    }
  });

  let arrow = "➖";
  let color = "text-gray-500";
  let displayValue = "0";

  if (best && best.improvement > 0) {
    arrow = "▲";
    color = "text-green-600 font-bold";
    displayValue = `${best.improvement}`;
  } else if (best && best.improvement < 0) {
    arrow = "▼";
    color = "text-red-600 font-bold";
    displayValue = `${best.improvement}`;
  }

  return (
    <div className="p-4 bg-white shadow rounded-xl">
      <h1 className="mb-4">Most Improved Ranking (AJSS)</h1>
      {best ? (
        <>
          <p className="font-medium">{best.playerName}</p>
          <p className="text-sm text-gray-500 mb-2">
            ({best.ageGroup})
          </p>
          <p className={`text-lg ${color}`}>
            {arrow} {displayValue}{" "}
            <span className="text-sm text-gray-600">
              ({best.worst} → {best.best})
            </span>
          </p>
        </>
      ) : (
        <p>No data</p>
      )}
    </div>
  );
}
